import * as Immutable from 'immutable';
import * as React from 'react';
import { DropzoneRef } from 'react-dropzone'
import IPatternStore from '../../_stores/PatternStore';
import PatternBrowserCategoryListContainer from '../_containers/PatternBrowserCategoryListContainer';
import Loader from '../../../Common/_components/Loader';
import ModalContainer from '../../../Common/_containers/ModalContainer';
import TextInput from '../../../Common/_components/TextInput';
import { Grid, Button, Card, Input } from '@mui/material';
import { Trans } from 'react-i18next';
import { MaxOffset, PatternsPerPage } from '../../PatternDesignServiceSettings';

export type Props = {
	title: JSX.Element | string
	selectedPattern?: string
	selectedPatternCategory?: string
	opened?: boolean
	element?: JSX.Element
	onClose?: Function
	onOpen?: Function
	onSelect?: (id: string, categoryId: string) => void
	loading?: boolean
	offset?: number
	patterns?: Immutable.OrderedMap<string, IPatternStore>
	selectedCategoryId?: number
	onSetOffset?: Function
}

type State = {
	search: string
	isDragActive: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class PatternBrowser extends React.Component<Props, State> {
	private dropzoneRef:React.RefObject<DropzoneRef>;

	state = {
		search: "",
		isDragActive: false,
	} as State

	constructor(props:Props, state:State){
		super(props);
		this.dropzoneRef = React.createRef();
	}

	private onSearch = (search:string) => {
		this.setState({search:search});
	}

	render = () => {
		return <ModalContainer darken opened={this.props.opened} persist element={this.props.element} animate onOpen={this.props.onOpen} onClose={this.props.onClose} content={<>
			<div className="library-browser">
				<Card elevation={24}>
					<Grid container className="library-browser-header">
						<Grid item xs={12}>
							<h3>{this.props.title}</h3>
							<TextInput label={<T>Search</T>} value={this.state.search} onChange={(value:string) => this.onSearch(value)}/>
						</Grid>
					</Grid>
					<div className="library-browser-body">
						<PatternBrowserCategoryListContainer opened={this.props.opened} selectedPattern={this.props.selectedPattern} selectedPatternCategory={this.props.selectedPatternCategory} search={this.state.search} onClose={this.props.onClose} onSelect={this.props.onSelect}/>
					</div>
					{ this.props.selectedCategoryId != 0 && <div className="library-browser-pagination">
							<Button color="secondary" disabled={this.props.offset <= 0 || this.props.loading} onClick={(e) => {
								this.props.onSetOffset(this.props.offset - PatternsPerPage);
							}}>←</Button>

							<Input disabled={this.props.loading} onChange={(e) => {
								this.props.onSetOffset(+e.currentTarget.value * PatternsPerPage);
							}} type="text" value={this.props.offset / PatternsPerPage}/>

							<Button disabled={this.props.offset >= MaxOffset || this.props.loading} color="secondary" onClick={(e) => {
								this.props.onSetOffset(this.props.offset + PatternsPerPage);
							}}>→</Button>
						</div>
					}
					<div className="library-browser-footer">
						<Button color="secondary" className="modal-close"><T>Close</T></Button>
					</div>
				</Card>
			</div>
			{ this.props.loading && <Loader noModal /> }
		</>} />
	}
}